import cx from 'classnames';
import { forwardRef } from 'react';

const CardStatus = forwardRef<HTMLDivElement, { color: string }>(({ color }, ref) => {
  return <div className={cx('card-status', `bg-${color}`)} ref={ref} />;
});

export default CardStatus;
